import * as React from 'react';
import { Button } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { TerminalCredential } from 'services/clients/credentials';
import { ActionMenu } from '../../../action-menu';
import { ActionHandler, SINGLE_SELECTION_ACTIONS } from '../../../../actions';

interface Props {
  credential: TerminalCredential;
  onAction: ActionHandler;
}

export const ActionDropdown: React.FC<Props> = (props) => {
  const { credential, onAction } = props;
  const [anchor, setAnchor] = React.useState<HTMLButtonElement | null>(null);
  return (
    <div>
      <Button
        onClick={(e) => {
          e.stopPropagation();
          setAnchor(e.currentTarget);
        }}
      >
        <MoreHorizIcon />
      </Button>
      <ActionMenu
        anchor={anchor}
        onClose={() => setAnchor(null)}
        onAction={(action) => {
          onAction(action, [credential.id]);
          setAnchor(null);
        }}
        enabledActions={SINGLE_SELECTION_ACTIONS}
      />
    </div>
  );
};
